import PonduranceContactInfo from './PonduranceContactInfo';

export { PonduranceContactInfo };

export default PonduranceContactInfo;
